import Page from '@service-victoria/component-library/components/Page';
import Text from '@service-victoria/component-library/components/Text';
import React, { useEffect } from 'react';
import * as Styled from '../../transactions/provider/steps/styled';
import { storage } from 'app/utils';

const TechnicalError: React.FC = () => {
  useEffect(() => {
    storage.clear();
  }, []);

  return (
    <Page title='New React Transaction'>
      <Styled.Wrapper>
        <Styled.HeadingWrapper>
          <Text.Heading.H1 fontWeight='bold'>Technical Error</Text.Heading.H1>
          <Styled.Spacer16 />
        </Styled.HeadingWrapper>
        <Styled.Spacer16 />
        <Text.Body>Sorry, we’ve experienced a technical error.</Text.Body>
      </Styled.Wrapper>
    </Page>
  );
};

export default TechnicalError;
